module.exports = __webpack_public_path__ + "img/Bear38.aa7810d6.jpg";